import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CompletedInsuranceToDoTaskPopup from './components/CompletedInsuranceToDoTaskPopup';
import InsuranceToDoTaskInProgressPopup from './components/InsuranceToDoTaskInProgressPopup';

const InsuranceToDoTaskPopup = ({ isCompleted, ...rest }) => {
  return (
    <Fragment>
      {isCompleted ? (
        <CompletedInsuranceToDoTaskPopup {...rest} />
      ) : (
        <InsuranceToDoTaskInProgressPopup {...rest} />
      )}
    </Fragment>
  );
};

InsuranceToDoTaskPopup.propTypes = {
  task: PropTypes.object,
  taskId: PropTypes.number,
  onClose: PropTypes.func,
  formatMessage: PropTypes.func,
  isCompleted: PropTypes.bool,
};

export default InsuranceToDoTaskPopup;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InsuranceToDoTaskPopup/index.jsx